export type { RequestConfig, ResponseConfig, ResponseErrorConfig } from './config'
import { BASE_API_URL } from '../endpoints.constants'
import { createClient } from './config'

export default createClient(BASE_API_URL, true)
